<template lang="pug">
include /@ibkr/lib.common/src/icon/color
//Filters was originally Industries
div(class="border-bottom search-by")
    ib-row(:class="{ 'pb-16': !$media.xl }")
        ib-col(class="xl2")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.l, 'start-24': $media.l}"
            ) {{ $t('search_by') }}
        ib-col(
            class="xl3 s12",
            :class="classes"
        )
            ib-button(
                @click="setTab('filters')",
                class="ml-0 text-left"
                :class="{ active: selectedTab === 'filters', fullWidth: !$media.xl }",
                ) {{ $t('filters') }}
                span(
                    v-if="selectedTab === 'filters'",
                    class="inset-8 fg-positive",
                )
                    +icon-color-yes
        ib-col(
            class="xl3 s12",
            :class="classes"
        )
            ib-button(
                @click="setTab('companies')",
                class="ml-0 text-left"
                :class="{ active: selectedTab === 'companies', fullWidth: !$media.xl }",
                ) {{ $t('your_companies') }}
                span(
                    v-if="selectedTab === 'companies'",
                    class="fg-positive",
                )
                    +icon-color-yes
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'SearchByType',
        data() {
            return {
                industry: true,
                company: false,
                classes: {
                    'flex-flex': $media.m, 
                    'insety-8': $media.l,
                    'insety-2': !$media.m,
                    'insetx-16': $media.l, 
                    'insetx-4': !$media.m
                }
            }
        },
        methods: {
            setTab(value) {
                this.setSelectedTab(value);
            },
            ...mapActions(['setSelectedTab'])
        },
        computed: {
            ...mapState(['selectedTab']),
        }
    }
</script>
<style lang="less">
.search-by {
    .pb-16 {
        padding-bottom: 16px;
    }
    button {
        svg {
            float: right;
        }
        &.ml-0 {
            margin-left: 0;
        }
        &.fullWidth {
            width: 100%;
            &:hover {
                border-color: #000;
                span {
                }
            }
        }
       &:hover {
           border-color: #000;
           span {
           }
       }
    }
}

</style>
